import './new-incident-type.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateIncidentType } from "@core/query/incident-type.query";
import { IncidentTypeFormRule, IncidentTypeFormSchema } from "@core/form/form.rule";
import { incidentTypeFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormIncidentType from "../form-incident-type/form-incident-type";

export function IncidentType() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateIncidentType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New IncidentType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addIncidentType, isLoading: isCreating } =
    useQyCreateIncidentType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<IncidentTypeFormSchema>({
    defaultValues: incidentTypeFormDefault,
    resolver: zodResolver(IncidentTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: IncidentTypeFormSchema) => {
    const formData = mapCreateIncidentType(form);
    addIncidentType(formData);
  };
  const handleValidateError = (err: FieldErrors<IncidentTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="IncidentType" className="incident-type">
      <HeaderContent
        title="New Incident Type"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormIncidentType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default IncidentType;